export const UIKIT_NAMESPACE = 'uikit'
